import { TimeSelectComponent } from './time_select_component';
export default TimeSelectComponent;
